import {Component, input, model} from '@angular/core';
import {Widget} from '../../models/dashboard';
import {Button} from 'primeng/button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-widget-header',
    standalone: true,
    imports: [
        Button,
        DragDropModule,
        CommonModule
    ],
    templateUrl: './widget-header.component.html',
    styleUrl: './widget-header.component.css'
})
export class WidgetHeaderComponent {
  data = input.required<Widget>();
  isEditable = input.required<boolean>();
  showOptions = model.required<boolean>();
}
